import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { extract } from "app/core/i18n/i18n.service";
import { Route } from "app/core/route/route.service";
import { SavingsTransactionComponent } from "./savings-transaction/savings-transaction.component";
import { CurrenciesResolver } from "app/home/resolvers/ currencies-resolver.service";

const routes: Routes = [
  Route.withShell([
    {
      path: "home/action/:name",
      component: SavingsTransactionComponent,
      data: {tile:'Ahorros', breadcrumb: 'Ahorros' },
      resolve: {
        supportedCurrencies: CurrenciesResolver
      }
    }
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SavingsTransactionsRoutingModule {}
